// Tab navigation constants for My Learning Dashboard
export enum LEARNING_TAB_TYPES {
  ENROLLED = "enrolled",
  COMPLETED = "completed",
  WATCH_LATER = "watchLater",
  CERTIFICATES = "certificates",
}

export const DEFAULT_LEARNING_TAB_INDEX = 0;

export const CERTIFICATES_TAB_INDEX = 3;
